import CarouselTimeLine from '../../sections/CarouselTimeLine/index';

document.addEventListener('click', (e) => {
  const anchor = e.target.closest('[data-scroll-animation]');
  if (!anchor) return;
  const href = anchor.getAttribute('href');
  if (!href || href.charAt(0) !== '#') return;
  const target = document.querySelector(href);
  if (!target) return;
  e.preventDefault();
  const targetTop = target.getBoundingClientRect().top + window.scrollY;
  window.scrollTo({ top: targetTop, behavior: 'smooth' });
  window.history.pushState(null, '', href);
});

window.smoothScroll = {
  animateScroll: (target) => window.scrollTo({ top: typeof target === 'number' ? target : 0, behavior: 'smooth' }),
};

CarouselTimeLine();
